<!-- eslint-disable -->
<template lang="pug">
        cs-modal(@close="$emit('close')", :is-blur="true")
                div(v-if="!this.successfullyAdded")
                        .detective-points-modal__header(slot="header")
                                | {{ $i18n.t('points.points_modal_detectivePointsChanging') }}
                        form.detective-points-modal__form(action="javascript://" @submit="updateDetectivePoints")
                                .detective-points-modal__item.detective-points-modal__text
                                        | {{ user.fullName }}
                                        | {{ detectivePointsString }}
                                cs-input.detective-points-modal__input(
                                        type="number"
                                        onkeydown="if (`${this.value}`.length >= 9 && event.keyCode !== 8) return false;"
                                        :placeholder="$i18n.t('points.points_modal_inputPlaceholder')"
                                        v-model.number="points"
                                        v-validate="'required|max:9'"
                                        v-focus="true"
                                        name="number"
                                        :data-vv-as="$i18n.t('points.points_modal_pointsCount')"
                                )
                                help-text(v-if="errors.has('number')" :error="errors.has('number')")
                                        | {{ errors.first('number') }}
                                .detective-points-modal__item.detective-points-modal__text--big
                                        | {{ $i18n.t('points.points_modal_total') }} {{ total }}
                                .detective-points-modal__buttons
                                        router-link.detective-points-modal__link(
                                                :to="routerObject"
                                        ) {{ $i18n.t('points.points_modal_detectivePointsChangingHistory') }}
                                        cs-button.detective-points-modal__button(
                                                color="blue"
                                                :loading="isLoading"
                                                :disabled="errors.has('number')"
                                                @click.prevent="updateDetectivePoints"
                                        ) {{ $i18n.t('points.points_modal_scorePoints') }}
                .detective-points-modal__add-miles_container(v-else)
                        span
                                svg-icon.detective-points-modal__add-miles_successfully-added(name="check", size="xx-large")
                        span.detective-points-modal__add-miles_text
                                | {{ $i18n.t('points.points_modal_pointsWasAdd') }}
</template>

<script>
    /*eslint-disable*/
    import UserApi from '../api/user/user'

    import CsModal from '../elements/CsModal.vue'
    import HelpText from '../elements/HelpText.vue'

    import { mapState } from 'vuex'

    export default {
        props: {
            user: Object,
        },
        components: {
            CsModal,
		        HelpText
        },
        data () {
            return {
                isLoading: false,
                points: 0,
                successfullyAdded: false
            }
        },
        methods: {
            updateDetectivePoints () {
                this.$validator.validateAll()
                    .then(response => {
                        if (response && this.points) {
                            this.isLoading = true;
                            this.$emit('detectivePoints', +this.points);
                            return UserApi.updateDetectivePoints(this.user.id, this.points)
                        }
                    })
                    .then(() => {
                        this.isLoading = false;
                        if (this.authUser.type === 'teacher') {
                            this.$toasted.success(this.$i18n.t('points.points_modal_requestWasSend'));
                        } else if (this.points > 0) {
                            this.$toasted.success(this.$i18n.t('points.points_modal_pointsWasAdd'));
                        } else {
                            this.$toasted.success(this.$i18n.t('points.points_modal_pointsWasRemove'));
                        }
                        this.successfullyAdded = !this.successfullyAdded;
                        setTimeout(() => {this.$emit('close');}, 5000)
                    })
                    .catch(() => {
                        this.isLoading = false;
                    })
            }
        },
        computed: {
            ...mapState({
                authUser: state => state.auth.user
            }),
            routerObject () {
                let route;
                if (this.$isDetectiveAvailable && this.$isMapAvailable) {
                    route = {name: 'histories-progress', params: {type: 'detective'}}
                } else if (this.$isDetectiveAvailable) {
                    route = {name: 'detective-points-history:list'};
                }
                Object.assign(route, {
                    query:
                        {
                            schoolId: this.user.grades[0] && this.user.grades[0].schoolId,
                            gradeId: this.user.grades[0] && this.user.grades[0].id,
                            userId: this.user.id
                        }
                });
                return route;
            },
            detectivePointsString () {
                return '(' + this.user.detectivePoints + ' '
                    + this.$i18n.tc('points.points_modal_pointsDeclination', this.user.detectivePoints) + ')';
            },
            total () {
                const points = this.user.detectivePoints + this.points;
                return points + ' ' + this.$i18n.tc('points.points_modal_pointsDeclination', points);
            },
        }
    }
</script>

<style lang="scss" scoped>
        .detective-points-modal__header {
                font-size: 22px;
                font-weight: 500;
                margin-top: 10px;
        }

		.detective-points-modal__form {
				margin-top: 25px;
				text-align: left;
		}

		.detective-points-modal__input {
				margin-top: 10px;
				&::-webkit-inner-spin-button,
				&::-webkit-outer-spin-button{
						appearance: none;
						margin: 0;
				}
		}

		.detective-points-modal__item {
				margin-top: 10px;
		}

		.detective-points-modal__text {
				font-weight: 500;
				font-size: 16px;
				line-height: 19px;
		}

		.detective-points-modal__text--big {
				font-weight: 500;
				font-size: 18px;
				line-height: 21px;
		}

		.detective-points-modal__buttons {
				margin-top: 15px;
				display: flex;
				flex-direction: column;
				@include media($md) {
						flex-direction: row;
						align-items: center;
						justify-content: space-between;
				}
		}

		.detective-points-modal__link {
				color: $hsl-color-blue-56;
				text-decoration: underline;
				margin-bottom: 20px;
				@include media($md) {
						margin-bottom: 0;
				}
		}

		.detective-points-modal__link:hover {
				color: $hsl-color-blue-56;
				text-decoration: none;
		}

		.detective-points-modal__button {
				max-width: 200px;
				@include media($md) {
						max-width: none;
				}
		}

        .detective-points-modal__add-miles_container {
                display: flex;
                flex-direction: column;
        }

        .detective-points-modal__add-miles_successfully-added {
                border-radius: 50%;
                color: $hsl-color-green-58;
                border: 4px solid $hsl-color-green-58;
                padding: 8px;
                margin-bottom: 20px;
        }

        .detective-points-modal__add-miles_text {
                font-size: 22px;
                font-weight: 500;
        }
</style>
